import { InteractionEvent } from '@tencent/alloy-renderer';

// touch 触发 mouse 事件的最大间隔，如果 touch 事件触发到 mouse 事件触发的时间间隔小于这个值，则认为这次 mouse 事件是 touch 行为触发的
const TOUCH_END_TO_MOUSE_EVENT_MAX_INTERVAL = 300;

class MouseEventSourceDetector {
    private touchendTime = 0;

    public constructor() {
        this.initEvent();
    }

    /**
     * 判断 mouse 事件是否由 touch 行为触发
     */
    public isTriggerByTouch = (event: MouseEvent | InteractionEvent | React.MouseEvent) => {
        const nativeEvent = ('nativeEvent' in event ? event.nativeEvent : event) as MouseEvent;
        // 如果支持 sourceCapabilities 属性，可以根据这个判断
        if ((nativeEvent as any).sourceCapabilities?.firesTouchEvents) {
            return true;
        }
        // 鼠标触发的 mousedown 事件 buttons 不可能为 0
        if (nativeEvent.type === 'mousedown') {
            return nativeEvent.buttons === 0;
        }
        // mouseup 事件的 buttons 也可能是 0，所以只能通过是否触发了 touchend 来判断
        return (nativeEvent.timeStamp - this.touchendTime) < TOUCH_END_TO_MOUSE_EVENT_MAX_INTERVAL;
    };

    /**
     * 判断 mouse 事件是否由鼠标行为触发
     */
    public isTriggerByMouse = (event: MouseEvent) => !this.isTriggerByTouch(event);

    private initEvent = () => {
        window.addEventListener('touchend', this.handleTouchEnd, true);
    };

    private handleTouchEnd = (event: TouchEvent) => {
        // 记录 touchend 触发的时间戳
        this.touchendTime = event.timeStamp;
    };
}

const mouseEventSourceDetector = new MouseEventSourceDetector();
export default mouseEventSourceDetector;
